import { render, staticRenderFns } from "./SpeechBubbleFloat.vue?vue&type=template&id=5e7d74d7"
import script from "./SpeechBubbleFloat.vue?vue&type=script&lang=ts"
export * from "./SpeechBubbleFloat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports